import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import { contemPermissaoTela } from "@/shared/helpers/Permissoes";

const Home = () =>
  import(/* webpackChunkName: "home" */ "@/views/Home/Home.vue");

const Login = () =>
  import(/* webpackChunkName: "login" */ "@/views/Login/Login.vue");

const Erro = () => import(/* webpackChunkName: "erro" */ "@/views/Erro/Erro");

// VALIDAÇÃO
const Validacao = () =>
  import(/* webpackChunkName: "validacao" */ "@/views/Validacao/Validacao.vue");
const ValidacaoDetalhes = () =>
  import(
    /* webpackChunkName: "validacaoDetalhe" */
    "@/views/ValidacaoDetalhes/ValidacaoDetalhes"
  );

// RELATÓRIOS
const Relatorios = () =>
  import(
    /* webpackChunkName: "relatorios" */
    "@/views/Relatorios/Relatorios.vue"
  );

// RELATÓRIO DE PRODUTIVIDADE
const RelatorioDeProdutividade = () =>
  import(
    /* webpackChunkName: "relatorioDeProdutividade" */
    "@/views/RelatorioDeProdutividade/RelatorioDeProdutividade.vue"
  );

// PRESTADORES
const Prestadores = () =>
  import(
    /* webpackChunkName: "prestadores" */
    "@/views/Prestadores/Prestadores.vue"
  );
const PrestadoresDetalhes = () =>
  import(
    /* webpackChunkName: "prestadoresDetalhes" */
    "@/views/PrestadoresDetalhe/PrestadoresDetalhe"
  );

// ADMINISTRAÇÃO
const AdministracaoSubTela = () =>
  import(
    /* webpackChunkName: "administracao sub tela" */
    "@/views/AdministracaoSubTela/AdministracaoSubTela.vue"
  );
const Administracao = () =>
  import(
    /* webpackChunkName: "administracao" */
    "@/views/Administracao/Administracao.vue"
  );
const AdministracaoValidacoes = () =>
  import(
    /* webpackChunkName: "administracao validacoes" */
    "@/views/AdministracaoValidacoes/AdministracaoValidacoes.vue"
  );
const AdministracaoDetalhe = () =>
  import(
    /* webpackChunkName: "AdministracaoDetalhe" */
    "@/views/AdministracaoDetalhe/AdministracaoDetalhe"
  );

// DASHBOARD
const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ "@/views/Dashboard/Dashboard");

// CONVERSOR XML
const ConversorXmlSubTela = () =>
  import(
    /* webpackChunkName: "conversor xml sub tela" */
    "@/views/ConversorXmlSubTela/ConversorXmlSubTela.vue"
  );
const ConversorXmlLayout = () =>
  import(
    /* webpackChunkName: "conversor xml layout" */
    "@/views/ConversorXmlLayout/ConversorXmlLayout.vue"
  );
const ConversorXmlArquivo = () =>
  import(
    /* webpackChunkName: "conversor xml arquivo" */
    "@/views/ConversorXmlArquivo/ConversorXmlArquivo.vue"
  );

// Recursos Próprios

const RecursosProprios = () =>
  import(
    /* webpackChunkName: "RecursosProprios" */
    "@/views/RecursosProprios/RecursosProprios"
  );
const QuestionarioLaboratorio = () =>
  import(
    /* webpackChunkName: "QuestionarioLaboratorio" */
    "@/views/RecursosPropriosQuestionarios/Laboratorio/QuestionarioLaboratorio"
  );
const QuestionarioHospital = () =>
  import(
    /* webpackChunkName: "QuestionarioHospital" */
    "@/views/RecursosPropriosQuestionarios/Hospital/QuestionarioHospital"
  );
const QuestionarioHospitalDia = () =>
  import(
    /* webpackChunkName: "QuestionarioHospitalDia" */
    "@/views/RecursosPropriosQuestionarios/HospitalDia/QuestionarioHospitalDia"
  );
const QuestionarioCentroDiagnostico = () =>
  import(
    /* webpackChunkName: "QuestionarioCentroDiagnostico" */
    "@/views/RecursosPropriosQuestionarios/CentroDiagnostico/QuestionarioCentroDiagnostico"
  );
const QuestionarioHomeCare = () =>
  import(
    /* webpackChunkName: "QuestionarioHomeCare" */
    "@/views/RecursosPropriosQuestionarios/HomeCare/QuestionarioHomeCare"
  );
const QuestionarioProntoSocorro = () =>
  import(
    /* webpackChunkName: "QuestionarioProntoSocorro" */
    "@/views/RecursosPropriosQuestionarios/ProntoSocorro/QuestionarioProntoSocorro"
  );
const QuestionarioProntoAtendimento = () =>
  import(
    /* webpackChunkName: "QuestionarioProntoAtendimento" */
    "@/views/RecursosPropriosQuestionarios/ProntoAtendimento/QuestionarioProntoAtendimento"
  );
const QuestionarioClinica = () =>
  import(
    /* webpackChunkName: "QuestionarioClinica" */
    "@/views/RecursosPropriosQuestionarios/Clinica/QuestionarioClinica"
  );
const QuestionarioClinicaEspecialidade = () =>
  import(
    /* webpackChunkName: "QuestionarioClinicaEspecialidade" */
    "@/views/RecursosPropriosQuestionarios/ClinicaEspecialidade/QuestionarioClinicaEspecialidade"
  );
const QuestionarioCentroOncologia = () =>
  import(
    /* webpackChunkName: "QuestionarioCentroOncologia" */
    "@/views/RecursosPropriosQuestionarios/CentroOncologia/QuestionarioCentroOncologia"
  );
const QuestionarioCentroMultiprofissional = () =>
  import(
    /* webpackChunkName: "QuestionarioCentroMultiprofissional" */
    "@/views/RecursosPropriosQuestionarios/CentroMultiprofissional/QuestionarioCentroMultiprofissional"
  );
const QuestionarioCentroHemodialise = () =>
  import(
    /* webpackChunkName: "QuestionarioCentroHemodialise" */
    "@/views/RecursosPropriosQuestionarios/CentroHemodialise/QuestionarioCentroHemodialise"
  );
const QuestionarioCentroHemodinamica = () =>
  import(
    /* webpackChunkName: "QuestionarioCentroHemodinamica" */
    "@/views/RecursosPropriosQuestionarios/CentroHemodinamica/QuestionarioCentroHemodinamica"
  );
const QuestionarioParceiroComercial = () =>
  import(
    /* webpackChunkName: "QuestionarioParceiroComercial" */
    "@/views/RecursosPropriosQuestionarios/ParceiroComercial/QuestionarioParceiroComercial"
  );

Vue.use(VueRouter);

const routes = [
  /// HOME
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      tela: "HOME"
    }
  },
  /// LOGIN
  {
    path: "/login",
    name: "Login",
    component: Login,
    props: true
  },
  /// VALIDAÇÃO
  {
    path: "/validacao",
    name: "Validacao",
    component: Validacao,
    meta: {
      tela: "VALIDACAO"
    }
  },
  {
    path: "/validacao/:id",
    name: "ValidacaoDetalhes",
    component: ValidacaoDetalhes,
    props: true,
    meta: {
      tela: "VALIDACAO_DETALHE"
    }
  },
  /// RELATÓRIOS
  {
    path: "/relatorios",
    name: "Relatorios",
    component: Relatorios,
    meta: {
      tela: "RELATORIOS"
    }
  },
  /// RELATÓRIO DE PRODUTIVIDADE
  {
    path: "/relatorio-produtividade",
    name: "Relatorio de Produtividade",
    component: RelatorioDeProdutividade,
    meta: {
      tela: "RELATORIO_PRODUTIVIDADE"
    }
  },
  /// ADMINISTRAÇÃO
  {
    path: "/administracao",
    name: "Administracao",
    component: AdministracaoSubTela,
    meta: {
      tela: "ADMINISTRACAO",
      keepAlive: false
    }
  },
  {
    path: "/administracao/unimeds",
    name: "Administracao Unimeds",
    component: Administracao,
    meta: {
      tela: "ADMINISTRACAO_UNIMEDS",
      keepAlive: false
    }
  },
  {
    path: "/administracao/validacoes",
    name: "Administracao Validações",
    component: AdministracaoValidacoes,
    meta: {
      tela: "ADMINISTRACAO_VALIDACOES",
      keepAlive: false
    }
  },
  {
    path: "/administracao/unimeds/:id",
    name: "DetalhesUnimed",
    component: AdministracaoDetalhe,
    props: true,
    meta: {
      tela: "ADMINISTRACAO_UNIMEDS"
    }
  },
  /// PRESTADORES
  {
    path: "/prestadores",
    name: "Prestadores",
    component: Prestadores,
    meta: {
      tela: "PRESTADORES"
    }
  },
  {
    path: "/prestadores/:id",
    name: "PrestadoresDetalhes",
    component: PrestadoresDetalhes,
    props: true,
    meta: {
      tela: "PRESTADORES_DETALHE"
    }
  },
  /// DASHBOARD
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      tela: "DASHBOARD"
    }
  },
  /// CONVERSOR XML
  {
    path: "/conversor-xml",
    name: "ConversorXml",
    component: ConversorXmlSubTela,
    meta: {
      tela: "CONVERSOR_XML",
      keepAlive: false
    }
  },
  {
    path: "/conversor-xml/layout",
    name: "ConversorXmlLayout",
    component: ConversorXmlLayout,
    meta: {
      tela: "CONVERSOR_XML_LAYOUT",
      keepAlive: false
    }
  },
  {
    path: "/conversor-xml/arquivo",
    name: "ConversorXmlArquivo",
    component: ConversorXmlArquivo,
    meta: {
      tela: "CONVERSOR_XML_ARQUIVO",
      keepAlive: false
    }
  },
  ///RECURSOS PRÓPRIOS
  {
    path: "/recursos-proprios",
    name: "Gestão de Recursos e Serviços Próprios",
    component: RecursosProprios,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/laboratorio",
    name: "Questionário Laboratório",
    component: QuestionarioLaboratorio,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/hospital",
    name: "Questionário Hospital",
    component: QuestionarioHospital,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/hospital_dia",
    name: "Questionário Hospital Dia",
    component: QuestionarioHospitalDia,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/centro_diagnostico",
    name: "Questionário Centro de Diagnóstico",
    component: QuestionarioCentroDiagnostico,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/home_care",
    name: "Questionário Home Care",
    component: QuestionarioHomeCare,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/pronto_socorro",
    name: "Questionário Pronto Socorro",
    component: QuestionarioProntoSocorro,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/pronto_atendimento",
    name: "Questionário Pronto Atendimento",
    component: QuestionarioProntoAtendimento,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/clinica",
    name: "Questionário Clínica",
    component: QuestionarioClinica,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/clinica_especialidade",
    name: "Questionário Clínica de Especialidade",
    component: QuestionarioClinicaEspecialidade,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/centro_oncologia",
    name: "Questionário Centro de Oncologia",
    component: QuestionarioCentroOncologia,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/centro_multiprofissional",
    name: "Questionário Centro Multiprofissional",
    component: QuestionarioCentroMultiprofissional,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/centro_hemodialise",
    name: "Questionário Centro de Hemodiálise",
    component: QuestionarioCentroHemodialise,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/centro_hemodinamica",
    name: "Questionário Centro de Hemodinâmica",
    component: QuestionarioCentroHemodinamica,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  {
    path: "/recursos-proprios/:id/questionario/parceiro_comercial",
    name: "Questionário Parceiro Comercial",
    component: QuestionarioParceiroComercial,
    meta: {
      tela: "RECURSOS_PROPRIOS"
    }
  },
  /// TELA DE ERRO
  {
    path: "/erro/:tipoErro",
    name: "Erro",
    component: Erro,
    props: true
  },
  {
    path: "*",
    redirect: "/home"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

function recuperarDadosUsuario() {
  store.commit("recuperarToken");
  store.commit("recuperarDadosUsuario");
}

recuperarDadosUsuario();

/**
 * Função ativada antes da entrada nas rotas
 */
router.beforeEach((to, from, next) => {
  store.dispatch("CANCEL_PENDING_REQUESTS");
  store.commit("setMostrarBread", false);
  if (to.meta && to.meta.tela) {
    const tela = to.meta.tela;
    if (!contemPermissaoTela(tela, store.getters.getPermissoesUsuario.telas)) {
      next("/erro/403");
      return;
    }
  }

  next();
});

export default router;
